import React from 'react'
import styled from 'styled-components'

import confettiImg from '@/assets/images/confetti.gif'

import { mobile } from './media-query'
import Carousel from './carousel'

const KitCarouselContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;

  @media ${mobile.query} {
    margin-bottom: ${({ theme }) => theme.sectionMobileMargin}px;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100px;
  }

  h1 {
    font-size: 46px;
    margin: 0 12px 44px;
    text-align: center;
  }

  @media ${mobile.query} {
    display: none;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media ${mobile.query} {
    width: 100%;
    margin: auto;
    flex-direction: column-reverse;
    overflow: visible;
  }
`

export const KitCarouselSection = () => {
  return (
    <KitCarouselContainer>
      <Header>
        <img alt="" src={confettiImg} />
        <h1>The GIPHY SDK solves problems so you don’t have to</h1>
      </Header>
      <Content>
        <Carousel />
      </Content>
    </KitCarouselContainer>
  )
}
